import { DATABASE } from "../../../config/firebase";
import { assignValueToObject } from "../types/promocode.data";

//addPromoCode

//deletePromoCode

//editPromoCode

type Listeners = {
  onUpdate?: Function,
  onAdd?: Function,
  onGetAll?: Function
}

type fetchActiveOrdersProps = {
  listeners: Listeners
}

export const fetchPromoCodes = ({ listeners } : fetchActiveOrdersProps) => {
  DATABASE.collection("promo_codes")
  .orderBy("createdAt")
  .onSnapshot((snapshot) => {
    snapshot.docChanges().forEach(function (change) {
      if (change.type === "added") {
        listeners && listeners.onAdd && listeners.onAdd({
          id: change.doc.id,
          data: change.doc.data()
        });
      }
      if(change.type === "modified") {
        listeners && listeners.onUpdate && listeners.onUpdate({
          id: change.doc.id,
          data: change.doc.data()
        });
      }
    });
    listeners && listeners.onGetAll && listeners.onGetAll({
      codes: snapshot.docs.map((q) => {        
        return assignValueToObject(q);
      })
    });
  });
}

export const fetchPromoCodesPaginated = async (limit: number, offset: number) => {
  try {
    // Get total count first
    const totalSnapshot = await DATABASE.collection("promo_codes").get();
    const totalCount = totalSnapshot.size;
    
    // For Firestore, we'll use a simpler approach by fetching all documents
    // and then slicing them client-side. For better performance with large datasets,
    // you would implement cursor-based pagination with startAfter/endBefore
    const snapshot = await DATABASE.collection("promo_codes")
      .orderBy("createdAt", "desc")
      .get();
    
    const allDocs = snapshot.docs;
    const startIndex = offset;
    const endIndex = Math.min(startIndex + limit, allDocs.length);
    const pageDocs = allDocs.slice(startIndex, endIndex);
    
    const codes = pageDocs.map((doc: any) => assignValueToObject(doc));
    
    return {
      codes,
      totalCount
    };
  } catch (error) {
    console.log("fetchPromoCodesPaginated error: ", error);
    throw error;
  }
}

export const fetchAllPromoCodes = async () => {
  try {
    const snapshot = await DATABASE.collection("promo_codes")
      .orderBy("createdAt", "desc")
      .get();
    
    const codes = snapshot.docs.map((doc: any) => assignValueToObject(doc));
    
    return codes;
  } catch (error) {
    console.log("fetchAllPromoCodes error: ", error);
    throw error;
  }
}

export const Delete = async (id: string) => {
  try {
    await DATABASE.collection("promo_codes").doc(id).delete();
  } catch (error) {
    console.log("promocode delete error: ", error)
  }
}

export const create = async (promoCode: any) => {
  try {
    await DATABASE.collection("promo_codes").add(promoCode);
  } catch (error) {
    console.log("promocode create error: ", error)
  }
  
}

export const update = async(id:string, promoCode: any) => {
  try {
    await DATABASE.collection("promo_codes").doc(id).update(promoCode);
  } catch (error) {
    console.log("promocode update error: ", error)
  }
  
}
